import { HttpStatus } from '../../../services/http/statusCodes';
import { ErrorPage } from '../ErrorPage';

export function InternalServerError() {
  return <ErrorPage title={HttpStatus.INTERNAL_SERVER_ERROR} description="Sorry, something went wrong on our side" />;
}
